export class SearchFilterModel {
    allCheck = false;
    agentCheck = false;
    peopleCheck = false;
    employeeCheck = false;
    selectedState = "";
    ascendingOrder = true;

}
